import React from 'react';

const StepFour = ({ data }) => {
    const { basicInfosObject, contactInfosObject, otherDetailsObject } = data;

    const renderField = (label, value) => (
        <div style={{ marginBottom: '0.5rem' }}>
            <label className="label" style={{ marginBottom: '0.2rem' }}>{label}:</label>
            <span>{value || 'Vide'}</span>
        </div>
    );

    return (
        <section id="step-recap" className='container section pt-0 mt-0'>
            {/* BASIC INFO */}
            <div className="columns recap-section mt-3">
                <div className="column">
                    <h3 className="subtitle is-5">Informations basiques</h3>
                    {renderField('Pays', basicInfosObject.country)}
                    {renderField('Nom de l\'entreprise', basicInfosObject.name)}
                    {renderField('Email', basicInfosObject.email)}
                    {basicInfosObject.country === 'France'
                        ? renderField('SIREN', basicInfosObject.siren)
                        : renderField('Company ID Number', basicInfosObject.companyID)
                    }
                    {renderField('Forme juridique', basicInfosObject.legalForm)}
                    {renderField('Numéro de TVA', basicInfosObject.vatNumber)}
                </div>
            </div>

            <hr />

            {/* CONTACT INFO */}
            <div className="columns recap-section mt-3">
                <div className="column">
                    <h3 className="subtitle is-5">Informations de contact</h3>
                    {renderField('Numéro de téléphone', contactInfosObject.phone_number)}
                    {renderField('Site web', contactInfosObject.website)}
                    {renderField('Adresse', contactInfosObject.address)}
                    {renderField('Ville', contactInfosObject.city)}
                    {renderField('Code Postal', contactInfosObject.postal_code)}
                </div>
            </div>

            <hr />

            {/* OTHER DETAILS */}
            <div className="columns recap-section mt-3">
                <div className="column">
                    <h3 className="subtitle is-5">Détails additionnels</h3>
                    {renderField('Secteur', otherDetailsObject.industry)}
                    {renderField('Taille de l\'entreprise', otherDetailsObject.size)}
                    {renderField('Est une startup', otherDetailsObject.is_startup ? 'Oui' : 'Non')}
                </div>
            </div>
        </section>
    );
};

export default StepFour;